// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Delivery } from './delivery';
import { Order } from './order';
import { PackingSlip } from './packing-slip';
import { PurchaseOrder } from './purchase-order';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Photo extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  get type() {
    return this.deliveryId ? 'Delivery' : this.orderId ? 'Order' : this.packingSlipId ? 'Pack Slip' : 'Purchase Order';
  }
  get displayType() {
    return this.deliveryId ? 'Delivery Stack' : this.orderId ? 'Order' : this.packingSlipId ? 'Pack Slip / Invoice' : 'Purchase Order';
  }

  get linkId() {
    return this.deliveryId ? this.deliveryId : this.orderId ? this.orderId : (this.packingSlipId ?  this.packingSlipId : this.purchaseOrderId);
  }

  userCanDelete: boolean;
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  created!: Date;
  createdBy?: string;
  deleted?: Date;
  deletedBy?: string;
  deliveryId?: number;
  filename?: string;
  name?: string;
  notes?: string;
  orderId?: number;
  packingSlipId?: number;
  purchaseOrderId?: number;
  delivery!: Delivery;
  order!: Order;
  packingSlip!: PackingSlip;
  purchaseOrder!: PurchaseOrder;
}

